// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n\ttransition: opacity 0.2s ease-out;\n}\n.fade-enter,\n.fade-leave-to {\n\topacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
